module.exports = __webpack_public_path__ + "img/Insurance.1e1d8f1f.svg";